import { getModalByTemplate } from "../../../modal";

import { scrollToTop } from '../../../_src/components/scroll-to-top/scroll-to-top.js';
import { initializeVLibrasAfterLoad } from '../../../_src/components/vlibras/vlibras.js';

const FOOTER_ACCORDION_QUERY = "(max-width: 1224px)";

const receiveNewsByEmail = () => {
    const form = document.querySelector(".footer-ifag__columns__form");
    const inputEmail = document.querySelector('#footer-ifag__news__input-email');
    const inputName = document.querySelector('#footer-ifag__news__input-name');

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        if (validateFields(inputName, inputEmail)) submitData(inputName, inputEmail);
    })
}

const validateFields = (inputName, inputEmail) => {
    const nameRegex = /^[A-Za-zÀ-ÿ\s]{2,}$/;

    if (!nameRegex.test(inputName.value.trim())) {
        getModalByTemplate("generic-error", {
            title: "Nome inválido",
            description: "Digite um nome válido com pelo menos 2 letras.",
        });

        return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(inputEmail.value.trim())) {
        getModalByTemplate("generic-error", {
            title: "E-mail inválido",
            description: "Digite um endereço de e-mail válido.",
        });

        return false;
    }

    return true
}

const submitData = (inputName, inputEmail) => {
    const submitBtn = document.querySelector(".footer-ifag__columns__form__button");
    const CRAFT_CSRF_NAME = window.csrfTokenName;
    const CRAFT_CSRF_TOKEN = window.csrfTokenValue;

    submitBtn.classList.add("loading", "disabled");

    let formData = new FormData()
    formData.append(CRAFT_CSRF_NAME, CRAFT_CSRF_TOKEN);
    formData.append('newsletter-email', inputEmail.value);
    formData.append('newsletter-nome', inputName.value);

    fetch('/actions/general-module/newsletter/cadastro-newsletter', {
        method: "POST",
        body: formData,
    })
    .then((response) => {
        return response.json();
    })
    .then((json) => {
        if(!json.success) {
            return getModalByTemplate("generic-error", {
                title: "Não foi possível realizar o seu cadastro",
                description: json.message,
            });
        }

        getModalByTemplate("generic-error", {
            icon: "<i class='fa-regular fa-circle-check'></i>",
            title: "Cadastro finalizado com sucesso!",
            description: json.message,
        });

        inputEmail.value = "";
        inputName.value = "";
    })
    .catch((error) => {
        getModalByTemplate("generic-error", {
            title: "Não foi possível realizar o seu cadastro",
            description: error,
        });
    })
    .finally(() => {
        submitBtn.classList.remove("loading", "disabled");
    });
}

const initFooterAccordion = () => {
    const footer = document.querySelector("[data-ifag-footer-accordion]");
    const mobileFooter = window.matchMedia(FOOTER_ACCORDION_QUERY);

    if (!footer) {
        return;
    }

    const panels = Array.from(footer.querySelectorAll("[data-ifag-footer-panel]"));

    const setPanelOpen = (panel, isOpen) => {
        const trigger = panel.querySelector("[data-ifag-footer-trigger]");
        const content = panel.querySelector("[data-ifag-footer-content]");

        panel.classList.toggle("footer-ifag__column--open", isOpen);
        trigger?.setAttribute("aria-expanded", String(isOpen));

        if (content) {
            content.hidden = mobileFooter.matches && !isOpen;
        }
    };

    const openOnly = panelToOpen => {
        panels.forEach(panel => setPanelOpen(panel, panel === panelToOpen));
    };

    const setTriggersDisabled = isDisabled => {
        panels.forEach(panel => {
            const trigger = panel.querySelector("[data-ifag-footer-trigger]");

            if (trigger) {
                trigger.disabled = isDisabled;
            }
        });
    };

    const syncPanels = () => {
        if (!mobileFooter.matches) {
            setTriggersDisabled(true);
            panels.forEach(panel => setPanelOpen(panel, true));
            return;
        }

        setTriggersDisabled(false);
        const defaultPanel = panels.find(panel => panel.dataset.ifagFooterDefaultOpen === "true") ?? panels[0];
        openOnly(defaultPanel);
    };

    panels.forEach(panel => {
        const trigger = panel.querySelector("[data-ifag-footer-trigger]");

        trigger?.addEventListener("click", () => {
            if (!mobileFooter.matches) {
                return;
            }

            openOnly(panel);
        });
    });

    if (mobileFooter.addEventListener) {
        mobileFooter.addEventListener("change", syncPanels);
    } else {
        mobileFooter.addListener(syncPanels);
    }

    syncPanels();
};

document.addEventListener('DOMContentLoaded', () => {
    scrollToTop();
    initFooterAccordion();
    initializeVLibrasAfterLoad();
})

/* COMENTÁRIO TEMPORÁRIO */
/* if(document.querySelector(".footer-ifag")) {
    receiveNewsByEmail();
} */
